module.exports = __webpack_public_path__ + "img/04-1-1常用服务.893abe59.png";